import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { homeData } from "../../../redux/HomeSlice";
import Loader from "../../common/Loader";

const PopularTest = () => {
  const dispatch = useDispatch();
  const responseHome = useSelector((state) => state.homeReducer.data);
  const isLoading = useSelector((state) => state.homeReducer.isLoading);
  const homeError = useSelector((state) => state.homeReducer.error);
  const [homeData2, setHomeData] = useState(null);

  useEffect(() => {
    dispatch(homeData());
  }, [dispatch]);

  useEffect(() => {
    if (responseHome != null && responseHome.status === 1) {
      setHomeData(responseHome.data.packages);
    }
  }, [responseHome]);

  return (
    <div className="popular_card_sec">
      <div className="coustom_container">
        <h3>Popular Health Packages</h3>
        {isLoading && <Loader message="Loading packages..." />}
        {homeError && <p className="text-danger text-center">{homeError}</p>}
        <Row>
          {homeData2 != null &&
            homeData2.map((item) => (
              <Col lg={4} md={6} sm={12} key={item._id || item.id}>
                <Card className="custom-card">
                  <div className="card_title_img">
                    <Card.Title>{item.name}</Card.Title>
                  </div>
                  <Card.Body>
                    {(item.description || []).map((desc, index) => (
                      <div className="card_img" key={index}>
                        <Card.Text>- {desc}.</Card.Text>
                      </div>
                    ))}
                    <div className="buy_now">
                      <div className="buy_now_text">
                        <span>₹{item.amount}</span>
                      </div>
                      <div className="buy_now_offer">
                        <img src={item.image} alt="offer" />
                      </div>
                    </div>
                    <div className="card_btn">
                      <Link
                        to="https://play.google.com/store/search?q=kior+healthcare&c=apps&hl=en"
                        target="_blank"
                      >
                        Buy Now <NavigateNextOutlinedIcon />
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </div>
    </div>
  );
};

export default PopularTest;
